/*
|
|--------------------------------------------------------------------------
| Main JS File
|--------------------------------------------------------------------------
| If js does not belong to a specific template, module, or other
| directory the code probably goes here. A utility function
| would be a good example of this use case.
|
*/
//--------------------------------------------------------------------------
// Setup Toastr defaults
//--------------------------------------------------------------------------

toastr.options = {
    "closeButton": true,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "3000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
};
import '../../page-transitions/barba-init';
import '../../page-transitions/barba-script-reload';
import '../../page-transitions/delete-cache';
import '../../page-transitions/transition-controler';
